import update from 'immutability-helper';
import * as types from './types';

type Zoom = [number, number];
type Brush = [number, number];
type Interval = [string, string];

export enum ENGAGEMENT_TYPE {
  playDuration = 'play-duration',
  endPlays = 'end-plays',
}

export interface IState {
  defaultZoom: Zoom,
  defaultBrush: Brush,
  zoom: Zoom,
  brush: Brush,
  interval: Interval,
  chartType: 'line' | 'bar' | '',
  engagementType: ENGAGEMENT_TYPE,
  bucket: string,
  trendsChartCompareTrigger: boolean,
  tableCompareEnabled: boolean
}

const initialState: IState = {
  defaultZoom: [0, 100],
  defaultBrush: [0, 0],
  zoom: [0, 100],
  brush: [0, 0],
  interval: ['', ''],
  chartType: '',
  engagementType: ENGAGEMENT_TYPE.endPlays,
  bucket: '',
  trendsChartCompareTrigger: false,
  tableCompareEnabled: false
};

const switchMap: {
  [key in keyof typeof types]?: (state: IState, action: Partial<{ type: keyof typeof types }>) => IState;
} = {};

switchMap[types.INIT_CHART] = (state) => update(state, {
  $set: initialState,
});

switchMap[types.RESET_CHART] = (state) => update(state, {
  $set: {
    ...initialState,
    chartType: state.chartType,
    engagementType: state.engagementType,
    trendsChartCompareTrigger: state.trendsChartCompareTrigger,
  },
});

switchMap[types.SET_DEFAULT_SLICE] = (state, action) => update(state, {
  $merge: {
    defaultZoom: action.defaultZoom,
    defaultBrush: action.defaultBrush,
  },
});

switchMap[types.SET_SLICE] = (state, action) => {
  return update(state, {
    $merge: {
      zoom: action.zoom,
      brush: action.brush,
    },
  })};

switchMap[types.RESET_SLICE] = (state) => update(state, {
  $merge: initialState,
});

switchMap[types.SET_INTERVAL] = (state, action) => update(state, {
  interval: {
    $set: action.interval,
  },
});

switchMap[types.SET_CHART_TYPE] = (state, action) => update(state, {
  chartType: {
    $set: action.chartType,
  },
});

switchMap[types.TOGGLE_ENGAGEMENT_TYPE] = (state) => update(state, {
  engagementType: {
    $set: state.engagementType === ENGAGEMENT_TYPE.playDuration
      ? ENGAGEMENT_TYPE.endPlays
      : ENGAGEMENT_TYPE.playDuration,
  },
});

switchMap[types.SET_ENGAGEMENT_TYPE] = (state, action) => update(state, {
  engagementType: {
    $set: action.engagementType,
  },
});

switchMap[types.SET_BUCKET] = (state, action) => update(state, {
  bucket: {
    $set: action.bucket,
  },
});

switchMap[types.SWITCH_ZOOM_BRUSH] = (state) => update(state, {
  $merge: {
    defaultZoom: state.zoom,
    defaultBrush: state.brush,
  },
});

switchMap[types.INJECT_SHARED_STATE] = (state, action) => update(state, {
  $merge: action.state,
});

switchMap[types.ENABLE_TABLE_COMPARE] = (state, action) => update(state, {
  tableCompareEnabled: {
    $set: action.flag,
  },
});

switchMap[types.TRENDS_CHART_COMPARE_TRIGGER] = (state, action) => update(state, {
  trendsChartCompareTrigger: {
    $set: action.checked,
  },
});

export default (state = initialState, action) => (
  switchMap[action.type]
    ? switchMap[action.type](state, action)
    : state
);
